import { Connection, EpochInfo } from "@solana/web3.js";
import { secondsBetweenSlots, slotTimeSecondsFor } from "./slotTime";

export async function getEpochStartDate(connection: Connection, epoch: number) {
    const epochSchedule = await connection.getEpochSchedule();
    const currentEpochInfo = await getCurrentEpochInfo(connection);
    const averageSlotTime = slotTimeSecondsFor(currentEpochInfo.epoch); // in seconds

    if (epoch < currentEpochInfo.epoch) {
        throw new Error("This function is designed for current or future epochs.");
    }

    // Calculate the starting slot of the future epoch
    const futureEpochStartSlot = epochSchedule.slotsPerEpoch * epoch + epochSchedule.firstNormalSlot;

    // Get the block time for the current slot
    const currentBlockTime = await connection.getBlockTime(currentEpochInfo.absoluteSlot);

    if (currentBlockTime === null) {
        throw new Error('Unable to fetch current block time.');
    }

    // Calculate the number of slots between the current slot and the future epoch start slot
    const slotsUntilFutureEpoch = futureEpochStartSlot - currentEpochInfo.absoluteSlot;

    // Calculate the time difference (in seconds) between the current slot and the future epoch's start slot
    const timeToFutureEpoch = slotsUntilFutureEpoch * averageSlotTime;

    // Calculate the start date of the future epoch
    const futureEpochStartDate = new Date((currentBlockTime + timeToFutureEpoch) * 1000);
    
    return futureEpochStartDate;
}

export const fetchUnstakeTime = (slotUnstaked: number, epochInfo: EpochInfo) => {
  const slotsPerEpoch = epochInfo.slotsInEpoch
  const currentSlot = epochInfo.absoluteSlot
  const unstakeEpoch = Math.floor(slotUnstaked / slotsPerEpoch)
  const withdrawableEpoch = unstakeEpoch + 2
  const withdrawableSlot = withdrawableEpoch * slotsPerEpoch

  let availableDate: Date | null = null
  let estimatedTimeToClaim: string | null = null
  if (withdrawableSlot > currentSlot) {
    const timeDiff = secondsBetweenSlots(currentSlot, withdrawableSlot, slotsPerEpoch)
    availableDate = new Date(Date.now() + (timeDiff * 1000))
    const days = Math.floor(timeDiff / (24 * 3600));
    const hours = Math.floor((timeDiff % (24 * 3600)) / 3600);
    estimatedTimeToClaim = `~${days}d ${hours}h`;
  }
  return { availableEpoch: withdrawableEpoch, availableSlot: withdrawableSlot, availableDate: availableDate, estimatedTimeToClaim: estimatedTimeToClaim }
}

// Function to get the current epoch info
export async function getCurrentEpochInfo(connection: Connection) {
    const epochInfo = await connection.getEpochInfo();
    return epochInfo;
}
